import type { IconDef } from '../types';

export const mail: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M23 3H1C0.45 3 0 3.45 0 4V19.77C0 20.32 0.45 20.77 1 20.77H23C23.55 20.77 24 20.32 24 19.77V4C24 3.45 23.55 3 23 3ZM20.15 5.21L12.05 12.13L3.45 4.77L20.16 5.21H20.15ZM1.82 18.51L2.14 6.29L11.4 14.2C11.59 14.36 11.82 14.44 12.05 14.44C12.28 14.44 12.51 14.36 12.7 14.2L22.15 6.13L21.81 19.03L1.82 18.51Z',
    },
  ],
};
